// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Modal } from 'react-bootstrap';
// import {
//   FaShoppingCart,
//   FaTrash,
//   FaMinus,
//   FaPlus,
//   FaPalette,
//   FaTimes,
// } from 'react-icons/fa';
// import './cart.scss';
// import FurnitureNavbar from '../../../../components/layout/Nav';
// import withAuth from '../../../auth/WithAuth';
// import { serverUrlAuth } from '../../../../serverUrl';
// import { toast } from 'react-toastify';

// const CartPage = () => {
//   const navigate = useNavigate();
//   const [cartData, setCartData] = useState(null);
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedItems, setSelectedItems] = useState(new Set());
//   const [selectAll, setSelectAll] = useState(false);
  
//   // Modal states
//   const [showClearCartModal, setShowClearCartModal] = useState(false);
//   const [showRemoveSelectedModal, setShowRemoveSelectedModal] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);

//   // Fetch cart items from API
//   useEffect(() => {
//     fetchCart();
//   }, []);

//   const fetchCart = async () => {
//     try {
//       setLoading(true);
//       const response = await serverUrlAuth.get('cart/');
//       console.log('Cart response:', response.data);
      
//       const data = response.data;
//       setCartData(data);
      
//       // Transform API data - use the prices directly from API
//       const transformedItems = (data.items || []).map(item => ({
//         id: item.id,
//         name: item.product?.name || 'Product',
//         category: item.product?.category || 'General',
//         // Use the prices directly from API - already discounted if on sale
//         unitPrice: parseFloat(item.unit_price || 0),
//         originalPrice: parseFloat(item.variant?.original_price || item.product?.original_price || 0),
//         sellingPrice: parseFloat(item.variant?.selling_price || 0),
//         quantity: item.quantity,
//         // Use variant images or product images
//         image: item.variant?.images?.[0]?.image || 
//                item.product?.images?.[0]?.image || 
//                'https://via.placeholder.com/100x100?text=No+Image',
//         inStock: (item.variant?.stock || 0) > 0,
//         stockCount: item.variant?.stock || 0,
//         productId: item.product?.id,
//         variantId: item.variant?.id,
//         // Variant info
//         colorName: item.variant?.color_name || 'Default',
//         colorCode: item.variant?.color_code || '#000000',
//         // Full objects for reference
//         variant: item.variant,
//         product: item.product,
//         // Pricing from API
//         totalPrice: parseFloat(item.total_price || 0),
//         discountAmount: parseFloat(item.discount_amount || 0),
//         discountPercentage: parseFloat(item.discount_percentage || 0),
//         // Sale info from API
//         isOnSale: item.variant?.is_on_sale || false,
//         saleStartDate: item.variant?.sale_start_date || null,
//         saleEndDate: item.variant?.sale_end_date || null,
//       }));
      
//       console.log('Transformed items:', transformedItems);
//       setCartItems(transformedItems);
      
//       // Start with nothing selected
//       setSelectedItems(new Set());
      
//     } catch (error) {
//       console.error('Error fetching cart:', error);
//       toast.error('Failed to load cart items');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update select all state when selections change
//   useEffect(() => {
//     const availableItems = cartItems.filter((item) => item.inStock);
//     const selectedAvailableItems = Array.from(selectedItems).filter(
//       (id) => cartItems.find((item) => item.id === id)?.inStock,
//     );

//     if (
//       availableItems.length > 0 &&
//       selectedAvailableItems.length === availableItems.length
//     ) {
//       setSelectAll(true);
//     } else {
//       setSelectAll(false);
//     }
//   }, [selectedItems, cartItems]);

//   const toggleItemSelection = (itemId) => {
//     const item = cartItems.find((i) => i.id === itemId);
//     if (!item?.inStock) return;

//     setSelectedItems((prev) => {
//       const newSet = new Set(prev);
//       if (newSet.has(itemId)) {
//         newSet.delete(itemId);
//       } else {
//         newSet.add(itemId);
//       }
//       return newSet;
//     });
//   };

//   const toggleSelectAll = () => {
//     if (selectAll) {
//       setSelectedItems(new Set());
//     } else {
//       const availableItemIds = cartItems
//         .filter((item) => item.inStock)
//         .map((item) => item.id);
//       setSelectedItems(new Set(availableItemIds));
//     }
//   };

//   const updateQuantity = async (id, newQuantity) => {
//     if (newQuantity < 1) return;
    
//     const item = cartItems.find((i) => i.id === id);
//     if (item && newQuantity > item.stockCount) {
//       toast.error(`Only ${item.stockCount} items available in stock`);
//       return;
//     }

//     try {
//       await serverUrlAuth.patch(`cart/update/${id}/`, {
//         quantity: newQuantity
//       });
      
//       // Update local state
//       setCartItems((items) =>
//         items.map((item) =>
//           item.id === id ? { ...item, quantity: newQuantity } : item,
//         )
//       );
      
//       // Update cart totals
//       await fetchCart();
      
//       toast.success('Cart updated');
//     } catch (error) {
//       console.error('Error updating cart:', error);
//       toast.error(error.response?.data?.error || 'Failed to update cart');
//     }
//   };

//   const removeItem = async (id, itemName) => {
//     try {
//       await serverUrlAuth.delete(`cart/remove/${id}/`);
      
//       setCartItems((items) => items.filter((item) => item.id !== id));
//       setSelectedItems((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(id);
//         return newSet;
//       });
      
//       // Update cart totals
//       await fetchCart();
      
//       toast.success(`${itemName || 'Item'} removed from cart`);
//     } catch (error) {
//       console.error('Error removing item:', error);
//       toast.error('Failed to remove item');
//     }
//   };

//   const handleRemoveSelected = () => {
//     if (selectedItems.size === 0) return;
//     setShowRemoveSelectedModal(true);
//   };

//   const confirmRemoveSelected = async () => {
//     setActionLoading(true);
//     try {
//       for (const id of selectedItems) {
//         await serverUrlAuth.delete(`cart/remove/${id}/`);
//       }
      
//       setCartItems((items) =>
//         items.filter((item) => !selectedItems.has(item.id)),
//       );
//       setSelectedItems(new Set());
//       setShowRemoveSelectedModal(false);
      
//       // Update cart totals
//       await fetchCart();
      
//       toast.success('Selected items removed');
//     } catch (error) {
//       console.error('Error removing items:', error);
//       toast.error('Failed to remove some items');
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleClearCart = () => {
//     setShowClearCartModal(true);
//   };

//   const confirmClearCart = async () => {
//     setActionLoading(true);
//     try {
//       for (const item of cartItems) {
//         await serverUrlAuth.delete(`cart/remove/${item.id}/`);
//       }
      
//       setCartItems([]);
//       setSelectedItems(new Set());
//       setShowClearCartModal(false);
      
//       // Update cart totals
//       await fetchCart();
      
//       toast.success('Cart cleared');
//     } catch (error) {
//       console.error('Error clearing cart:', error);
//       toast.error('Failed to clear cart');
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   // Calculate totals based on selected items only - using API prices
//   const calculateSelectedSubtotal = () => {
//     return cartItems
//       .filter((item) => selectedItems.has(item.id))
//       .reduce((sum, item) => sum + item.unitPrice * item.quantity, 0);
//   };

//   // Discount from API - already calculated
//   const calculateSelectedDiscount = () => {
//     return cartItems
//       .filter((item) => selectedItems.has(item.id))
//       .reduce((sum, item) => sum + (item.discountAmount || 0) * item.quantity, 0);
//   };

//   const calculateSelectedTax = () => {
//     return (calculateSelectedSubtotal()) * 0.16;
//   };

//   const calculateSelectedTotal = () => {
//     return (
//       calculateSelectedSubtotal() +
//       calculateSelectedTax()
//     );
//   };

//   const handleCheckout = () => {
//     if (selectedItems.size === 0) {
//       toast.warning('Please select items to checkout');
//       return;
//     }
    
//     // Get the selected cart items with their full data
//     const selectedCartItems = cartItems.filter(item => selectedItems.has(item.id));
    
//     // Pass the CartItem IDs to checkout
//     const cartItemIds = selectedCartItems.map(item => item.id);
    
//     navigate('/checkout', { 
//       state: { 
//         selectedItems: cartItemIds,
//         selectedCartItems: selectedCartItems,
//         total: calculateSelectedTotal(),
//         subtotal: calculateSelectedSubtotal(),
//         discount: calculateSelectedDiscount(),
//         tax: calculateSelectedTax(),
//       } 
//     });
//   };

//   const selectedCount = selectedItems.size;
//   const availableItemsCount = cartItems.filter((item) => item.inStock).length;

//   // Get color display
//   const getColorDisplay = (item) => {
//     if (item.colorName && item.colorCode) {
//       return (
//         <div className="variant-info">
//           <span 
//             className="color-swatch" 
//             style={{ backgroundColor: item.colorCode }}
//           />
//           <span>{item.colorName}</span>
//         </div>
//       );
//     }
//     return null;
//   };

//   // Helper to format currency
//   const formatCurrency = (amount) => {
//     if (!amount || amount === 0) return 'KSh 0';
//     return `KSh ${parseFloat(amount).toLocaleString()}`;
//   };

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="cart-page">
//           <div className="cart-container">
//             <div className="cart-loading">
//               <div className="spinner"></div>
//               <p>Loading your cart...</p>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }

//   if (cartItems.length === 0) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="cart-page">
//           <div className="cart-container">
//             <div className="empty-cart">
//               <div className="empty-cart-icon">🛒</div>
//               <h2>Your cart is empty</h2>
//               <p>Looks like you haven't added anything to your cart yet</p>
//               <Link to="/ready-made-products" className="continue-shopping-btn">
//                 <svg viewBox="0 0 24 24">
//                   <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
//                 </svg>
//                 Continue Shopping
//               </Link>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="cart-page">
//         <div className="cart-container">
//           {/* Cart Header */}
//           <div className="cart-header">
//             <div className="header-left">
//               <div className="cart-title">
//                 <h1>Your Cart</h1>
//                 <p className="item-count">
//                   <span>{cartItems.length}</span>{' '}
//                   {cartItems.length === 1 ? 'item' : 'items'} total
//                   {selectedCount > 0 && (
//                     <>
//                       {' '}
//                       · <span>{selectedCount}</span> selected
//                     </>
//                   )}
//                 </p>
//               </div>
//             </div>

//             <div className="header-actions">
//               {selectedCount > 0 && (
//                 <button className="remove-selected-btn" onClick={handleRemoveSelected}>
//                   <FaTrash /> Remove Selected ({selectedCount})
//                 </button>
//               )}
//               <button className="clear-cart-btn" onClick={handleClearCart}>
//                 <FaTrash /> Clear Cart
//               </button>
//             </div>
//           </div>

//           {/* Cart Items */}
//           <div className="cart-items-section">
//             {/* Select All Bar */}
//             {cartItems.some((item) => item.inStock) && (
//               <div className="select-all-bar">
//                 <div className="select-all-left">
//                   <label className="checkbox-wrapper">
//                     <input
//                       type="checkbox"
//                       checked={selectAll}
//                       onChange={toggleSelectAll}
//                       disabled={availableItemsCount === 0}
//                     />
//                     <span>Select All Items</span>
//                   </label>
//                 </div>
//                 <div className="selected-count">
//                   {selectedCount} of {availableItemsCount} selected
//                 </div>
//               </div>
//             )}

//             {cartItems.map((item) => (
//               <div
//                 key={item.id}
//                 className={`cart-item ${!item.inStock ? 'disabled' : ''}`}
//               >
//                 <div className="item-checkbox">
//                   <label className="checkbox-wrapper">
//                     <input
//                       type="checkbox"
//                       checked={selectedItems.has(item.id)}
//                       onChange={() => toggleItemSelection(item.id)}
//                       disabled={!item.inStock}
//                     />
//                   </label>
//                 </div>

//                 <div className="item-image">
//                   {item.image && item.image.startsWith('http') ? (
//                     <img src={item.image} alt={item.name} />
//                   ) : (
//                     <span>🛒</span>
//                   )}
//                   {/* Discount Badge - Only show if on sale */}
//                   {item.isOnSale && item.discountPercentage > 0 && (
//                     <div className="discount-badge">
//                       -{Math.round(item.discountPercentage)}%
//                     </div>
//                   )}
//                 </div>

//                 <div className="item-details">
//                   <div className="item-info">
//                     <h3 className="item-name">{item.name}</h3>
                    
//                     {/* Color/Variant Info */}
//                     {getColorDisplay(item) && (
//                       <div className="item-variant">
//                         {getColorDisplay(item)}
//                       </div>
//                     )}
                    
//                     <span className="item-category">
//                       {item.category?.charAt(0).toUpperCase() + item.category?.slice(1) || 'General'}
//                     </span>
                    
//                     <div className="item-pricing">
//                       <span className="item-price">
//                         {formatCurrency(item.unitPrice)}
//                       </span>
//                       {/* Only show original price if on sale and original > current */}
//                       {item.isOnSale && item.originalPrice > item.unitPrice && (
//                         <span className="item-original-price">
//                           {formatCurrency(item.originalPrice)}
//                         </span>
//                       )}
//                       {/* Only show SALE badge if actually on sale */}
//                       {item.isOnSale && (
//                         <span className="item-sale-badge">SALE</span>
//                       )}
//                     </div>
//                   </div>

//                   <div
//                     className={`stock-status ${
//                       !item.inStock
//                         ? 'out-of-stock'
//                         : item.stockCount <= 3
//                           ? 'low-stock'
//                           : 'in-stock'
//                     }`}
//                   >
//                     {!item.inStock ? (
//                       <>❌ Out of Stock</>
//                     ) : item.stockCount <= 3 ? (
//                       <>⚠️ Only {item.stockCount} left in stock</>
//                     ) : (
//                       <>✓ In Stock</>
//                     )}
//                   </div>
//                 </div>

//                 <div className="item-actions">
//                   <div className="quantity-control">
//                     <button
//                       onClick={() => updateQuantity(item.id, item.quantity - 1)}
//                       disabled={item.quantity <= 1 || !item.inStock}
//                     >
//                       <FaMinus />
//                     </button>
//                     <span>{item.quantity}</span>
//                     <button
//                       onClick={() => updateQuantity(item.id, item.quantity + 1)}
//                       disabled={
//                         !item.inStock || item.quantity >= item.stockCount
//                       }
//                     >
//                       <FaPlus />
//                     </button>
//                   </div>

//                   <div className="item-total">
//                     {formatCurrency(item.unitPrice * item.quantity)}
//                     <small>each</small>
//                   </div>

//                   <button
//                     className="remove-item"
//                     onClick={() => removeItem(item.id, item.name)}
//                   >
//                     <FaTrash />
//                     Remove
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Cart Summary */}
//           <div className="cart-summary">
//             <h2>Order Summary</h2>

//             <div className="selected-items-info">
//               {selectedCount === 0 ? (
//                 <span>No items selected</span>
//               ) : (
//                 <>
//                   Checking out with <span>{selectedCount}</span> selected
//                   item(s)
//                 </>
//               )}
//             </div>

//             <div className="summary-row">
//               <span className="label">Subtotal</span>
//               <span className="amount">
//                 {formatCurrency(calculateSelectedSubtotal())}
//               </span>
//             </div>

//             {/* Only show discount row if there's an actual discount */}
//             {calculateSelectedDiscount() > 0 && (
//               <div className="summary-row discount">
//                 <span className="label">Discount</span>
//                 <span className="amount discount-amount">
//                   -{formatCurrency(calculateSelectedDiscount())}
//                 </span>
//               </div>
//             )}

//             <div className="summary-row">
//               <span className="label">Tax (16%)</span>
//               <span className="amount">
//                 {formatCurrency(calculateSelectedTax())}
//               </span>
//             </div>

//             <div className="summary-row total">
//               <span>Total</span>
//               <span className="amount">
//                 {formatCurrency(calculateSelectedTotal())}
//               </span>
//             </div>

//             <button 
//               className="checkout-btn" 
//               disabled={selectedCount === 0}
//               onClick={handleCheckout}
//             >
//               {selectedCount === 0
//                 ? 'Select Items to Checkout'
//                 : 'Proceed to Checkout'}
//               <svg viewBox="0 0 24 24">
//                 <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
//               </svg>
//             </button>

//             <div className="payment-methods">
//               <span className="payment-icon">💳</span>
//               <span className="payment-icon">🏦</span>
//               <span className="payment-icon">📱</span>
//               <span className="payment-icon">💵</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Clear Cart Confirmation Modal */}
//       <Modal
//         show={showClearCartModal}
//         onHide={() => setShowClearCartModal(false)}
//         centered
//         className="delete-modal"
//       >
//         <Modal.Header closeButton>
//           <h2>Clear Cart</h2>
//         </Modal.Header>
//         <Modal.Body>
//           <p>
//             Are you sure you want to clear your entire cart? 
//             This action cannot be undone.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <button
//             className="btn btn-secondary"
//             onClick={() => setShowClearCartModal(false)}
//             disabled={actionLoading}
//           >
//             Cancel
//           </button>
//           <button
//             className="btn btn-danger"
//             onClick={confirmClearCart}
//             disabled={actionLoading}
//           >
//             {actionLoading ? 'Clearing...' : 'Clear Cart'}
//           </button>
//         </Modal.Footer>
//       </Modal>

//       {/* Remove Selected Items Confirmation Modal */}
//       <Modal
//         show={showRemoveSelectedModal}
//         onHide={() => setShowRemoveSelectedModal(false)}
//         centered
//         className="delete-modal"
//       >
//         <Modal.Header closeButton>
//           <h2>Remove Items</h2>
//         </Modal.Header>
//         <Modal.Body>
//           <p>
//             Are you sure you want to remove <strong>{selectedCount}</strong> selected item(s) from your cart?
//             This action cannot be undone.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <button
//             className="btn btn-secondary"
//             onClick={() => setShowRemoveSelectedModal(false)}
//             disabled={actionLoading}
//           >
//             Cancel
//           </button>
//           <button
//             className="btn btn-danger"
//             onClick={confirmRemoveSelected}
//             disabled={actionLoading}
//           >
//             {actionLoading ? 'Removing...' : 'Remove Items'}
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default withAuth(CartPage, 'client');



// src/pages/client/Cart/CartPage.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import {
  FaShoppingCart,
  FaTrash,
  FaMinus,
  FaPlus,
  FaArrowLeft,
  FaArrowRight,
  FaLock,
  FaCheckCircle,
  FaExclamationTriangle,
} from 'react-icons/fa';
import './cart.scss';
import Sidebar from '../../../../components/layout/Sidebar';
import withAuth from '../../../auth/WithAuth';
import { serverUrlAuth } from '../../../../serverUrl';
import { toast } from 'react-toastify';

const CartPage = () => {
  const navigate = useNavigate();
  const [cartData, setCartData] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItems, setSelectedItems] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);

  const [showClearCartModal, setShowClearCartModal] = useState(false);
  const [showRemoveSelectedModal, setShowRemoveSelectedModal] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    try {
      setLoading(true);
      const response = await serverUrlAuth.get('cart/');
      const data = response.data;
      setCartData(data);

      const transformedItems = (data.items || []).map((item) => ({
        id: item.id,
        name: item.product?.name || 'Product',
        category: item.product?.category || 'General',
        unitPrice: parseFloat(item.unit_price || 0),
        originalPrice: parseFloat(
          item.variant?.original_price || item.product?.original_price || 0,
        ),
        sellingPrice: parseFloat(item.variant?.selling_price || 0),
        quantity: item.quantity,
        image:
          item.variant?.images?.[0]?.image ||
          item.product?.images?.[0]?.image ||
          'https://via.placeholder.com/100x100?text=No+Image',
        inStock: (item.variant?.stock || 0) > 0,
        stockCount: item.variant?.stock || 0,
        productId: item.product?.id,
        variantId: item.variant?.id,
        colorName: item.variant?.color_name || 'Default',
        colorCode: item.variant?.color_code || '#000000',
        variant: item.variant,
        product: item.product,
        totalPrice: parseFloat(item.total_price || 0),
        discountAmount: parseFloat(item.discount_amount || 0),
        discountPercentage: parseFloat(item.discount_percentage || 0),
        isOnSale: item.variant?.is_on_sale || false,
        saleStartDate: item.variant?.sale_start_date || null,
        saleEndDate: item.variant?.sale_end_date || null,
      }));

      setCartItems(transformedItems);
      setSelectedItems(new Set());
    } catch (error) {
      console.error('Error fetching cart:', error);
      toast.error('Failed to load cart items');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const availableItems = cartItems.filter((item) => item.inStock);
    const selectedAvailableItems = Array.from(selectedItems).filter(
      (id) => cartItems.find((item) => item.id === id)?.inStock,
    );

    if (
      availableItems.length > 0 &&
      selectedAvailableItems.length === availableItems.length
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedItems, cartItems]);

  const toggleItemSelection = (itemId) => {
    const item = cartItems.find((i) => i.id === itemId);
    if (!item?.inStock) return;

    setSelectedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) newSet.delete(itemId);
      else newSet.add(itemId);
      return newSet;
    });
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems(new Set());
    } else {
      const availableItemIds = cartItems
        .filter((item) => item.inStock)
        .map((item) => item.id);
      setSelectedItems(new Set(availableItemIds));
    }
  };

  const updateQuantity = async (id, newQuantity) => {
    if (newQuantity < 1) return;

    const item = cartItems.find((i) => i.id === id);
    if (item && newQuantity > item.stockCount) {
      toast.error(`Only ${item.stockCount} items available in stock`);
      return;
    }

    try {
      await serverUrlAuth.patch(`cart/update/${id}/`, {
        quantity: newQuantity,
      });

      setCartItems((items) =>
        items.map((item) =>
          item.id === id ? { ...item, quantity: newQuantity } : item,
        ),
      );

      await fetchCart();
      toast.success('Cart updated');
    } catch (error) {
      console.error('Error updating cart:', error);
      toast.error(error.response?.data?.error || 'Failed to update cart');
    }
  };

  const removeItem = async (id, itemName) => {
    try {
      await serverUrlAuth.delete(`cart/remove/${id}/`);

      setCartItems((items) => items.filter((item) => item.id !== id));
      setSelectedItems((prev) => {
        const newSet = new Set(prev);
        newSet.delete(id);
        return newSet;
      });

      await fetchCart();
      toast.success(`${itemName || 'Item'} removed from cart`);
    } catch (error) {
      console.error('Error removing item:', error);
      toast.error('Failed to remove item');
    }
  };

  const handleRemoveSelected = () => {
    if (selectedItems.size === 0) return;
    setShowRemoveSelectedModal(true);
  };

  const confirmRemoveSelected = async () => {
    setActionLoading(true);
    try {
      for (const id of selectedItems) {
        await serverUrlAuth.delete(`cart/remove/${id}/`);
      }
      setCartItems((items) =>
        items.filter((item) => !selectedItems.has(item.id)),
      );
      setSelectedItems(new Set());
      setShowRemoveSelectedModal(false);
      await fetchCart();
      toast.success('Selected items removed');
    } catch (error) {
      console.error('Error removing items:', error);
      toast.error('Failed to remove some items');
    } finally {
      setActionLoading(false);
    }
  };

  const handleClearCart = () => setShowClearCartModal(true);

  const confirmClearCart = async () => {
    setActionLoading(true);
    try {
      for (const item of cartItems) {
        await serverUrlAuth.delete(`cart/remove/${item.id}/`);
      }
      setCartItems([]);
      setSelectedItems(new Set());
      setShowClearCartModal(false);
      await fetchCart();
      toast.success('Cart cleared');
    } catch (error) {
      console.error('Error clearing cart:', error);
      toast.error('Failed to clear cart');
    } finally {
      setActionLoading(false);
    }
  };

  const calculateSelectedSubtotal = () =>
    cartItems
      .filter((item) => selectedItems.has(item.id))
      .reduce((sum, item) => sum + item.unitPrice * item.quantity, 0);

  const calculateSelectedDiscount = () =>
    cartItems
      .filter((item) => selectedItems.has(item.id))
      .reduce(
        (sum, item) => sum + (item.discountAmount || 0) * item.quantity,
        0,
      );

  const calculateSelectedTax = () => calculateSelectedSubtotal() * 0.16;

  const calculateSelectedTotal = () =>
    calculateSelectedSubtotal() + calculateSelectedTax();

  const handleCheckout = () => {
    if (selectedItems.size === 0) {
      toast.warning('Please select items to checkout');
      return;
    }

    const selectedCartItems = cartItems.filter((item) =>
      selectedItems.has(item.id),
    );
    const cartItemIds = selectedCartItems.map((item) => item.id);

    navigate('/checkout', {
      state: {
        selectedItems: cartItemIds,
        selectedCartItems,
        total: calculateSelectedTotal(),
        subtotal: calculateSelectedSubtotal(),
        discount: calculateSelectedDiscount(),
        tax: calculateSelectedTax(),
      },
    });
  };

  const selectedCount = selectedItems.size;
  const availableItemsCount = cartItems.filter((item) => item.inStock).length;

  const getColorDisplay = (item) => {
    if (item.colorName && item.colorCode) {
      return (
        <div className="variant-info">
          <span
            className="color-swatch"
            style={{ backgroundColor: item.colorCode }}
          />
          <span>{item.colorName}</span>
        </div>
      );
    }
    return null;
  };

  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return 'KSh 0';
    return `KSh ${parseFloat(amount).toLocaleString()}`;
  };

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard cart-shell">
        <div className="cart-page">
          {/* Hero */}
          {/* <header className="hero-craftsmanship">
            <div className="hero-pattern"></div>
            <div className="hero-content-modern">
              <div className="welcome-badge">
                <FaShoppingCart className="badge-icon" />
                <span>Shopping Cart</span>
              </div>
              <h1 className="hero-title">
                <span className="gradient-text">Almost</span>
                <span className="hero-accent">Yours</span>
              </h1>
              <p className="hero-subtitle">
                Review your selected handcrafted pieces and proceed to
                checkout whenever you're ready.
              </p>
            </div>
          </header> */}

          <div className="cart-container">
            {loading ? (
              <div className="cart-loading">
                <div className="spinner"></div>
                <p>Loading your cart...</p>
              </div>
            ) : cartItems.length === 0 ? (
              <div className="empty-cart">
                <div className="empty-cart-icon">
                  <FaShoppingCart />
                </div>
                <h2>Your cart is empty</h2>
                <p>
                  Looks like you haven't added anything to your cart yet.
                </p>
                <Link
                  to="/ready-made-products"
                  className="continue-shopping-btn"
                >
                  <FaArrowLeft />
                  Continue Shopping
                </Link>
              </div>
            ) : (
              <>
                {/* Header */}
                <div className="cart-header">
                  <div className="header-left">
                    <div className="cart-title">
                      <h1>Your Cart</h1>
                      <p className="item-count">
                        <span>{cartItems.length}</span>{' '}
                        {cartItems.length === 1 ? 'item' : 'items'} total
                        {selectedCount > 0 && (
                          <>
                            {' '}
                            · <span>{selectedCount}</span> selected
                          </>
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="header-actions">
                    {selectedCount > 0 && (
                      <button
                        className="remove-selected-btn"
                        onClick={handleRemoveSelected}
                      >
                        <FaTrash /> Remove Selected ({selectedCount})
                      </button>
                    )}
                    <button
                      className="clear-cart-btn"
                      onClick={handleClearCart}
                    >
                      <FaTrash /> Clear Cart
                    </button>
                  </div>
                </div>

                {/* Items */}
                <div className="cart-items-section">
                  {cartItems.some((item) => item.inStock) && (
                    <div className="select-all-bar">
                      <div className="select-all-left">
                        <label className="checkbox-wrapper">
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={toggleSelectAll}
                            disabled={availableItemsCount === 0}
                          />
                          <span>Select All Items</span>
                        </label>
                      </div>
                      <div className="selected-count">
                        {selectedCount} of {availableItemsCount} selected
                      </div>
                    </div>
                  )}

                  {cartItems.map((item) => (
                    <div
                      key={item.id}
                      className={`cart-item ${!item.inStock ? 'disabled' : ''}`}
                    >
                      <div className="item-checkbox">
                        <label className="checkbox-wrapper">
                          <input
                            type="checkbox"
                            checked={selectedItems.has(item.id)}
                            onChange={() => toggleItemSelection(item.id)}
                            disabled={!item.inStock}
                          />
                        </label>
                      </div>

                      <div className="item-image">
                        {item.image && item.image.startsWith('http') ? (
                          <img src={item.image} alt={item.name} />
                        ) : (
                          <FaShoppingCart />
                        )}
                        {item.isOnSale && item.discountPercentage > 0 && (
                          <div className="discount-badge">
                            -{Math.round(item.discountPercentage)}%
                          </div>
                        )}
                      </div>

                      <div className="item-details">
                        <div className="item-info">
                          <h3 className="item-name">{item.name}</h3>

                          {getColorDisplay(item) && (
                            <div className="item-variant">
                              {getColorDisplay(item)}
                            </div>
                          )}

                          <span className="item-category">
                            {item.category?.charAt(0).toUpperCase() +
                              item.category?.slice(1) || 'General'}
                          </span>

                          <div className="item-pricing">
                            <span className="item-price">
                              {formatCurrency(item.unitPrice)}
                            </span>
                            {item.isOnSale &&
                              item.originalPrice > item.unitPrice && (
                                <span className="item-original-price">
                                  {formatCurrency(item.originalPrice)}
                                </span>
                              )}
                            {item.isOnSale && (
                              <span className="item-sale-badge">SALE</span>
                            )}
                          </div>
                        </div>

                        <div
                          className={`stock-status ${
                            !item.inStock
                              ? 'out-of-stock'
                              : item.stockCount <= 3
                                ? 'low-stock'
                                : 'in-stock'
                          }`}
                        >
                          {!item.inStock ? (
                            <>
                              <FaExclamationTriangle /> Out of Stock
                            </>
                          ) : item.stockCount <= 3 ? (
                            <>
                              <FaExclamationTriangle /> Only {item.stockCount}{' '}
                              left in stock
                            </>
                          ) : (
                            <>
                              <FaCheckCircle /> In Stock
                            </>
                          )}
                        </div>
                      </div>

                      <div className="item-actions">
                        <div className="quantity-control">
                          <button
                            onClick={() =>
                              updateQuantity(item.id, item.quantity - 1)
                            }
                            disabled={item.quantity <= 1 || !item.inStock}
                            aria-label="Decrease quantity"
                          >
                            <FaMinus />
                          </button>
                          <span>{item.quantity}</span>
                          <button
                            onClick={() =>
                              updateQuantity(item.id, item.quantity + 1)
                            }
                            disabled={
                              !item.inStock ||
                              item.quantity >= item.stockCount
                            }
                            aria-label="Increase quantity"
                          >
                            <FaPlus />
                          </button>
                        </div>

                        <div className="item-total">
                          {formatCurrency(item.unitPrice * item.quantity)}
                          <small>each</small>
                        </div>

                        <button
                          className="remove-item"
                          onClick={() => removeItem(item.id, item.name)}
                        >
                          <FaTrash />
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Summary */}
                <div className="cart-summary">
                  <h2>Order Summary</h2>

                  <div className="selected-items-info">
                    {selectedCount === 0 ? (
                      <span>No items selected</span>
                    ) : (
                      <>
                        Checking out with <span>{selectedCount}</span> selected
                        item(s)
                      </>
                    )}
                  </div>

                  <div className="summary-row">
                    <span className="label">Subtotal</span>
                    <span className="amount">
                      {formatCurrency(calculateSelectedSubtotal())}
                    </span>
                  </div>

                  {calculateSelectedDiscount() > 0 && (
                    <div className="summary-row discount">
                      <span className="label">Discount</span>
                      <span className="amount discount-amount">
                        -{formatCurrency(calculateSelectedDiscount())}
                      </span>
                    </div>
                  )}

                  <div className="summary-row">
                    <span className="label">Tax (16%)</span>
                    <span className="amount">
                      {formatCurrency(calculateSelectedTax())}
                    </span>
                  </div>

                  <div className="summary-row total">
                    <span>Total</span>
                    <span className="amount">
                      {formatCurrency(calculateSelectedTotal())}
                    </span>
                  </div>

                  <button
                    className="checkout-btn"
                    disabled={selectedCount === 0}
                    onClick={handleCheckout}
                  >
                    {selectedCount === 0
                      ? 'Select Items to Checkout'
                      : 'Proceed to Checkout'}
                    <FaArrowRight />
                  </button>

                  <div className="payment-methods">
                    <span className="payment-icon">💳</span>
                    <span className="payment-icon">🏦</span>
                    <span className="payment-icon">📱</span>
                    <span className="payment-icon">💵</span>
                  </div>

                  <div className="secure-note">
                    <FaLock /> Secure checkout · Buyer protection included
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Clear Cart Modal */}
        <Modal
          show={showClearCartModal}
          onHide={() => setShowClearCartModal(false)}
          centered
          className="cart-confirm-modal"
        >
          <Modal.Header closeButton>
            <h2>Clear Cart</h2>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to clear your entire cart? This action
              cannot be undone.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-cancel"
              onClick={() => setShowClearCartModal(false)}
              disabled={actionLoading}
            >
              Cancel
            </button>
            <button
              className="btn-danger"
              onClick={confirmClearCart}
              disabled={actionLoading}
            >
              {actionLoading ? 'Clearing...' : 'Clear Cart'}
            </button>
          </Modal.Footer>
        </Modal>

        {/* Remove Selected Modal */}
        <Modal
          show={showRemoveSelectedModal}
          onHide={() => setShowRemoveSelectedModal(false)}
          centered
          className="cart-confirm-modal"
        >
          <Modal.Header closeButton>
            <h2>Remove Items</h2>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to remove <strong>{selectedCount}</strong>{' '}
              selected item(s) from your cart? This action cannot be undone.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn-cancel"
              onClick={() => setShowRemoveSelectedModal(false)}
              disabled={actionLoading}
            >
              Cancel
            </button>
            <button
              className="btn-danger"
              onClick={confirmRemoveSelected}
              disabled={actionLoading}
            >
              {actionLoading ? 'Removing...' : 'Remove Items'}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default withAuth(CartPage, 'client');